import { render, staticRenderFns } from "./dialog-remove.vue?vue&type=template&id=32651a62&"
import script from "./dialog-remove.vue?vue&type=script&lang=js&"
export * from "./dialog-remove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dialog-remove.vue"
export default component.exports